<section *ngIf="data && data.length" class="mt-3 d-none d-sm-block" [ngClass]="{'d-none': !show}">
  <div matBadge="{{data.length}}" matBadgeColor="warn" matBadgeOverlap="false" matBadgePosition="after"></div>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="h6 text-nowrap mt-2" i18n>Neuhradené poplatky</div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
    <app-poplatok-item *ngFor="let p of data;" [poplatok]="p"></app-poplatok-item>
  </mat-expansion-panel>
</section>
